export class AppError extends Error {
    constructor(public readonly reason: string) {
        super(`AppError: ${reason}`);
    }
}
